var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConditioner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M271.054,753.288c-10.529,-9.209 -27.633,-7.892 -35.529,3.95c-9.208,10.524 -7.892,27.629 3.95,35.524c14.471,11.842 22.367,26.317 22.367,42.105c-0,15.791 -7.896,30.266 -22.367,42.108c-26.317,21.05 -40.792,51.312 -40.792,82.892c0,31.579 14.475,60.529 40.792,82.895c5.262,3.95 10.525,5.263 15.787,5.263c7.896,0 14.475,-2.629 19.738,-9.208c9.212,-10.529 7.896,-27.634 -3.946,-35.529c-14.475,-11.842 -22.371,-26.313 -22.371,-42.105c0,-15.787 7.896,-30.262 22.371,-42.104c26.313,-21.054 40.788,-51.316 40.788,-82.896c-0,-31.579 -14.475,-60.525 -40.788,-82.895Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.104,753.288c-10.525,-9.209 -27.629,-7.892 -35.525,3.95c-9.212,10.524 -7.896,27.629 3.946,35.524c14.475,11.842 22.371,26.317 22.371,42.105c-0,15.791 -7.896,30.266 -22.371,42.108c-26.313,21.05 -40.788,51.312 -40.788,82.892c0,31.579 14.476,60.529 40.788,82.895c5.262,3.95 10.529,5.263 15.792,5.263c7.896,0 14.471,-2.629 19.737,-9.208c9.208,-10.529 7.892,-27.634 -3.95,-35.529c-14.471,-11.842 -22.366,-26.313 -22.366,-42.105c-0,-15.787 7.895,-30.262 22.366,-42.104c26.317,-21.054 40.792,-51.316 40.792,-82.896c1.317,-31.579 -13.158,-60.525 -40.792,-82.895Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.475,753.288c-10.529,-9.209 -27.633,-7.892 -35.529,3.95c-9.208,10.524 -7.892,27.629 3.95,35.524c14.471,11.842 22.366,26.317 22.366,42.105c0,15.791 -7.895,30.266 -22.366,42.108c-26.317,21.05 -40.792,51.312 -40.792,82.892c0,31.579 14.475,60.529 40.792,82.895c5.262,3.95 10.525,5.263 15.787,5.263c7.896,0 14.475,-2.629 19.738,-9.208c9.212,-10.529 7.896,-27.634 -3.946,-35.529c-14.475,-11.842 -22.371,-26.313 -22.371,-42.105c0,-15.787 7.896,-30.262 22.371,-42.104c26.313,-21.054 40.787,-51.316 40.787,-82.896c0,-31.579 -14.475,-60.525 -40.787,-82.895Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.84,753.288c-10.525,-9.209 -27.629,-7.892 -35.525,3.95c-9.213,10.524 -7.896,27.629 3.946,35.524c14.475,11.842 22.37,26.317 22.37,42.105c0,15.791 -7.895,30.266 -22.37,42.108c-26.317,21.05 -40.788,51.312 -40.788,82.892c0,31.579 14.471,60.529 40.788,82.895c5.262,3.95 10.525,5.263 15.791,5.263c7.892,0 14.471,-2.629 19.733,-9.208c9.213,-10.529 7.896,-27.634 -3.945,-35.529c-14.475,-11.842 -22.367,-26.313 -22.367,-42.105c0,-15.787 7.892,-30.262 22.367,-42.104c26.316,-21.054 40.791,-51.316 40.791,-82.896c0,-31.579 -14.475,-60.525 -40.791,-82.895Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.32,201.975l-1052.63,0c-53.946,0 -98.683,44.738 -98.683,98.683l-0,282.896c-0,53.946 44.737,98.683 98.683,98.683l1052.63,0c53.946,0 98.683,-44.737 98.683,-98.683l0,-282.896c0,-53.946 -44.737,-98.683 -98.683,-98.683Zm-1052.63,51.312l1052.63,0c26.316,0 47.366,21.055 47.366,47.371l0,115.788l-1147.37,-0l-0,-115.788c-0,-26.316 21.05,-47.371 47.366,-47.371Zm1052.63,377.634l-1052.63,-0c-26.316,-0 -47.366,-21.054 -47.366,-47.367l-0,-115.792l1147.37,0l0,115.792c0,26.313 -21.05,47.367 -47.366,47.367Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1111.84,523.025l-973.684,0c-14.475,0 -25,11.842 -25,25c0,13.158 11.842,25 25,25l973.684,0c14.475,0 25,-11.842 25,-25c-0,-13.158 -11.842,-25 -25,-25Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.32,361.183l60.525,0c14.475,0 25,-11.841 25,-25c-0,-14.47 -11.842,-25 -25,-25l-60.525,0c-14.475,0 -25,11.842 -25,25c-1.317,13.159 10.525,25 25,25Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.367,361.183l60.529,0c14.471,0 25,-11.841 25,-25c-0,-14.47 -11.842,-25 -25,-25l-60.529,0c-14.471,0 -25,11.842 -25,25c-1.313,13.159 10.529,25 25,25Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditioner);
export default __webpack_public_path__ + "static/media/conditioner.2e7e8f30.svg";
export { ForwardRef as ReactComponent };